import { render, staticRenderFns } from "./SubscriptionAgreement-fr.vue?vue&type=template&id=f1d988c6&"
import script from "./SubscriptionAgreement-fr.vue?vue&type=script&lang=js&"
export * from "./SubscriptionAgreement-fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports